'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '.business-events', {
            abstract: true,
            url: "/business-events?"
            + "cf_ClerkInvoice_page?"
            + "&cf_ClerkInvoice_sent_from_clerk_tax_entity_id?"
            + "&cf_ClerkInvoice_sent_to_clerk_tax_entity_id?"
            + "&cf_ClerkInvoice_max_abs_amount?"
            + "&cf_ClerkInvoice_min_abs_amount?"
            + "&cf_ClerkInvoiceRow_page?"
            + "&cf_ClerkInvoiceRow_max_abs_amount?"
            + "&cf_ClerkInvoiceRow_min_abs_amount?"
            ,
            params: {
                curateStep: {dynamic: false},
                cf_ClerkInvoice_page: {value: '1', dynamic: true},
                cf_ClerkInvoice_sent_from_clerk_tax_entity_id: {value: '', dynamic: true},
                cf_ClerkInvoice_sent_to_clerk_tax_entity_id: {value: '', dynamic: true},
                cf_ClerkInvoice_max_abs_amount: {value: '', dynamic: true},
                cf_ClerkInvoice_min_abs_amount: {value: '', dynamic: true},
                cf_ClerkInvoiceRow_page: {value: '1', dynamic: true},
                cf_ClerkInvoiceRow_max_abs_amount: {value: '', dynamic: true},
                cf_ClerkInvoiceRow_min_abs_amount: {value: '', dynamic: true},
            },
            template: require("./inspect.business-events.html"),
        })

        .state('' + baseState + '.business-events.overview', {
            url: "/overview",
            template: require("./inspect.business-events.overview.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkInvoice_columns_by_step = 'attributes';
                },
            },
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.business-events.add-images-and-or-pdfs', {
            url: "/add-images-and-or-pdfs",
            template: require("./inspect.business-events.add-images-and-or-pdfs.html"),
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkInvoice_columns_by_step = 'add-images-and-or-pdfs';
                },
            },
            data: {pageTitle: 'Inspect'}
        })

        /*
        .state('' + baseState + '.business-events.sent-yet-unpaid-invoices', {
            url: "/sent-yet-unpaid-invoices",
            template: require("./inspect.business-events.sent-yet-unpaid-invoices.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.business-events.received-yet-unpaid-invoices', {
            url: "/received-yet-unpaid-invoices",
            template: require("./inspect.business-events.received-yet-unpaid-invoices.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.business-events.subscriptions', {
            url: "/subscriptions",
            template: require("./inspect.business-events.subscriptions.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.business-events.representations', {
            url: "/subscriptions",
            template: require("./inspect.business-events.representations.html"),
            data: {pageTitle: 'Inspect'}
        });
        */

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.business-events.**', {
        url: "/business-events",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/business-events/business-events.js